// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"dedd3740","145":"f0fcbaa9","419":"a765e2df","450":"4c1d4504","516":"fd80369c","538":"80e33bf2","699":"7e8ab75a","746":"0b79a616","852":"63b900ee","927":"d9b1cf2e"}[chunkId] + ".chunk.js";
};